import * as React from 'react';

import { cn } from '@/lib/core';

interface TextareaProps extends React.ComponentProps<'textarea'> {
  error?: boolean;
}

function Textarea({ className, error, ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      aria-invalid={error ? 'true' : undefined}
      className={cn(
        'bg-jncquoi-neutral-00 flex min-h-20 w-full rounded-none',
        'border-jncquoi-neutral-200 border border-solid',
        'px-3.75 py-2',
        'font-pp-neue-montreal text-jncquoi-neutral-1000 text-[14px] tracking-[0.5px]',
        'placeholder:text-jncquoi-neutral-600',
        'focus-visible:border-jncquoi-neutral-900 focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-jncquoi-asia-7427c-500',
        'resize-y transition-colors',
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
